(function () {
	let visible = false;
	let menu = document.querySelector('.menu');
	let burger = document.querySelector('.burger');
	
	function show() {
		menu.classList.add('menu_visible');
		burger.classList.add('burger_open');
		visible = true;
	}
	
	function hide() {
		menu.classList.remove('menu_visible');
		burger.classList.remove('burger_open');
		visible = false;
	}
	
	burger.addEventListener('click', function (e) {
		e.stopPropagation();
		visible ? hide() : show();
	});
	
	window.addEventListener('click', hide);
})();